import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { ListCollections } from '../components/Shopify/Collections';

const HeroShopifyCollections = props => {
  //console.log(props);
  return (
    <StaticQuery
      query={graphql`
        query collectionsSliceQuery {
          shopify {
            collections(first: 25, sortKey: UPDATED_AT) {
              edges {
                ...shopifyCollectionCard
              }
            }
          }
        }
      `}
      render={data => {
        return <ListCollections collections={data.shopify.collections.edges} />;
      }}
    />
  );
};

HeroShopifyCollections.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroShopifyCollections;
